export default {
  pending: null,
};
